/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-underscore-dangle */
import { Container, Box, Typography } from '@mui/material';

const LegalNotice = () => {
  return (
    <Container sx={{ px: 0, pb: 4 }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mt: 6, mb: 2 }}>
        Legal Notice
      </Typography>
      <Box
        sx={{
          px: 3,
          py: 3,
          backgroundColor: '#f5f5f5',
          borderRadius: 2,
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          maxWidth: 1000,
          mx: 'auto',
          color: '#444',
          fontSize: '0.95rem',
          lineHeight: 1.8,
          textAlign: 'left',
        }}
      >
        <Typography fontWeight="bold" gutterBottom>
          Legal
        </Typography>
        <Typography paragraph>
          NOTICE TO USER: THIS IS A CONTRACT. BY PROCEEDING WITH THE
          INSTALLATION OF THE SOFTWARE YOU ACCEPT ALL THE TERMS AND CONDITIONS
          OF THIS AGREEMENT. If you do not agree with the terms and conditions
          of this Agreement, please return the entire software package with the
          blank registration card, to Digital Anarchy, Inc. (&ldquo;Digital
          Anarchy&rdquo;) or the location where you obtained it.
        </Typography>

        <Typography paragraph>
          This package contains software (&ldquo;Software&rdquo;) and related
          explanatory written materials (&ldquo;Documentation&rdquo;). The term
          &ldquo;Software&rdquo; shall also include any upgrades, modified
          versions, updates, additions and copies of the Software licensed to
          you by Digital Anarchy. Digital Anarchy grants you a nonexclusive
          license to use the Software and Documentation provided that you agree
          to the following: Digital Anarchy
        </Typography>
        <Typography paragraph>
          1. Use of the Software. You may install the Software in a single
          location on a single hard disk. You may make one backup copy of the
          Software, provided it is not installed on any other computer. The
          primary user of the computer on which the Software is installed or
          used may also install the Software on one home or portable computer.
          However, the Software may not be used on the secondary computer by
          another person at the same time the Software on the primary computer
          is being used.
        </Typography>
        <Typography paragraph>
          2. Copyright. The Software is owned by Digital Anarchy and its
          structure, organization and code are the valuable trade secrets of
          Digital Anarchy. The Software is also protected by United States
          Copyright Law and International Treaty provisions. You must treat the
          Software just as you would any other copyrighted material, such as a
          book. You may not copy the Software, or Documentation, except as set
          forth in the &ldquo;Use of the Software&rdquo; section. Any copies
          that you are permitted to make pursuant to this Agreement must contain
          the same copyright and proprietary notices that appear on or in the
          Software. You agree not to modify, adapt, translate, reverse engineer,
          decompile, disassemble or otherwise attempt to discover the source
          code of the Software. Trademarks shall be used in accordance with
          accepted trademark practice, including identification of trademark
          owner&apos;s name. Trademarks can only be used to identify graphics
          output produced by the Software. Such use of any trademarks does not
          give you any rights of ownership in that trademark. Except as stated
          above, this agreement does not grant you any intellectual property
          rights in the Software.
        </Typography>
        <Typography paragraph>
          3. Transfer. You may not rent, lease, sublicense or lend the Software,
          or Documentation. You may, however, transfer all your rights to use
          the Software to another person or legal entity provided that you
          transfer this Agreement, the Software, including all copies, updates,
          and prior versions, and all Documentation to such person or entity and
          that you retain no copies.
        </Typography>
        <Typography paragraph>
          4. Multiple Environment Software. If this package contains, or, in
          connection with the acquisition of the Software contained in this
          package you receive, two or more operating environment versions (e.g.,{' '}
          Macintosh<sup>®</sup> or Windows<sup>®</sup>), and/or otherwise you
          receive two or more copies of the Software, the total aggregate number
          of computers on which all versions of the Software are used may not
          exceed one except under the conditions stated above. You may make one
          back-up copy, in accordance with the terms of this Agreement, for each
          version of the Software you use. You may not rent, lease, sublicense,
          lend or transfer versions or copies of the Software you do not use, or
          Software contained on any unused media, except as part of the
          permanent transfer of all Software and Documentation as described
          above.
        </Typography>

        <Typography paragraph>
          5. Limited Warranty. Digital Anarchy warrants to you that the Software
          will perform substantially in accordance with the Documentation for
          the ninety (90) day period following your receipt of the Software. To
          make a warranty claim, you must return the Software to the location
          where you obtained it, along with a copy of your sales receipt within
          such ninety (90) day period. If the Software does not perform
          substantially in accordance with the Documentation, the entire and
          exclusive liability and remedy shall be limited to either, at Digital
          Anarchy&apos;s option, the replacement of the Software or the refund
          of the license fee you paid for the Software. DIGITAL ANARCHY AND ITS
          SUPPLIERS DO NOT AND CANNOT WARRANT THE PERFORMANCE OR RESULTS YOU MAY
          OBTAIN BY USING THE SOFTWARE OR DOCUMENTATION. THE FOREGOING STATES
          THE SOLE AND EXCLUSIVE REMEDIES FOR DIGITAL ANARCHY&apos;S OR ITS
          SUPPLIER&apos;S BREACH OF WARRANTY. EXCEPT FOR THE FOREGOING LIMITED
          WARRANTY, DIGITAL ANARCHY AND ITS SUPPLIERS MAKE NO WARRANTIES,
          EXPRESS OR IMPLIED, AS TO NONINFRINGEMENT OF THIRD PARTY RIGHTS,
          MERCHANTABILITY, OR FITNESS FOR ANY PARTICULAR PURPOSE. IN NO EVENT
          WILL DIGITAL ANARCHY OR ITS SUPPLIERS BE LIABLE TO YOU FOR ANY
          CONSEQUENTIAL, INCIDENTAL OR SPECIAL DAMAGES, INCLUDING ANY LOST
          PROFITS OR LOST SAVINGS, EVEN IF AN DIGITAL ANARCHY REPRESENTATIVE HAS
          BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, OR FOR ANY CLAIM BY
          ANY THIRD PARTY. Some states or jurisdictions do not allow the
          exclusion or limitation of incidental, consequential or special
          damages, or the exclusion of implied warranties or limitations on how
          long an implied warranty may last, so the above limitations may not
          apply to you. To the extent permissible, any implied warranties are
          limited to ninety (90) days. This warranty gives specific legal
          rights. You may have other rights which vary from state to state or
          jurisdiction to jurisdiction. &ldquo;Digital Anarchy&rdquo;
        </Typography>
        <Typography paragraph>
          6. Governing Law and General Provisions. This Agreement will be
          governed by the laws in force in the state of California excluding the
          application of its conflicts of law rules. This Agreement will not be
          governed by the United Nations Convention on Contracts for the
          International Sale of Goods, the application of which is expressly
          excluded. If any part of this Agreement is found void and
          unenforceable, it will not affect the validity of the balance of the
          Agreement, which shall remain valid and enforceable according to its
          terms. You agree that the Software will not be shipped, transferred or
          exported into any country or used in any manner prohibited by the
          United States Export Administration Act or any other export laws,
          restrictions or regulations. This Agreement shall automatically
          terminate upon failure by you to comply with its terms. This Agreement
          may only be modified in writing signed by an authorized officer of
          Digital Anarchy.
        </Typography>
        <Typography paragraph>
          Digital Anarchy is a trademark of Digital Anarchy, Inc. which may be
          registered in certain jurisdictions. Macintosh is a registered
          trademark of Apple Computer, Inc. Windows is a trademark of Microsoft
          Corp.
        </Typography>
        <Typography paragraph>
          IMPORTANT: READ BEFORE DOWNLOADING, COPYING, INSTALLING OR USING
        </Typography>
        <Typography paragraph>
          {' '}
          By downloading, copying, installing or using the software you agree to
          this license. If you do not agree to this license, do not download,
          install, copy or use the software.
        </Typography>
      </Box>
    </Container>
  );
};

export default LegalNotice;
